import { Injectable, OnDestroy } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';

/**
 * ONE LEVEL ABOVE THE ACTION MONITOR (`action-monitor.component.scss`, `z-index: 1100`).
 */
export const RUN_CHAT_OVERLAY_Z_INDEX = 1101;

/**
 * THE RUN CHAT'S OWN OVERLAY LAYER (XAT-E-617-01). The app's overlay container sits at Material's `z-index: 1000`, under
 * the Action Monitor, so the composer's + menu, its Attach submenu, the model picker and the tooltips the run chat opened
 * were drawn behind the window they belong to: the + looked dead.
 *
 * Provided on `RunThreadChatComponent`, so it is what the chat's menus and tooltips get: Material creates their overlays
 * through the opener's injector (`createOverlayRef(injector)`), and the chat is created into that component's view. A
 * dialog is opened through its service's injector and stays in the app's container — so does everything the page opens,
 * and a dialog Autopilot drives stays under the monitor, with Stop reachable.
 *
 * A second `.cdk-overlay-container`, so the theme's overlay rules style it as they do the app's; it goes with the chat.
 */
@Injectable()
export class RunChatOverlayContainer extends OverlayContainer implements OnDestroy {
  protected override _createContainer(): void {
    super._createContainer();
    this._containerElement.classList.add('run-chat-overlay-container');
    this._containerElement.style.zIndex = String(RUN_CHAT_OVERLAY_Z_INDEX);
  }

  /** Is this element drawn in the run chat's layer? Never creates the layer to answer. */
  holds(element: Element | null | undefined): boolean {
    return !!element && !!this._containerElement?.contains(element);
  }
}
